// Line icon (mockup App.icon): 24×24 stroke icons, decorative unless a label is given.
import { createElement, type CSSProperties } from 'react';
import { cls } from '../lib/util';
import { ICON_PATHS, type IconName } from './icon-paths';

export type { IconName };

const camel = (k: string) => k.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase());

export interface IconProps {
  name: IconName;
  className?: string;
  /** Accessible name — only for icons that carry meaning on their own. */
  label?: string;
  size?: number;
}

export function Icon({ name, className, label, size }: IconProps) {
  const els = ICON_PATHS[name] ?? ICON_PATHS.dot;
  const style: CSSProperties | undefined = size ? { width: size, height: size } : undefined;
  return (
    <svg
      viewBox="0 0 24 24"
      className={cls('ic', `ic-${name}`, className)}
      aria-hidden={label ? undefined : 'true'}
      role={label ? 'img' : undefined}
      aria-label={label}
      focusable="false"
      style={style}
    >
      {els.map(([tag, attrs], i) =>
        createElement(tag, { key: i, ...Object.fromEntries(Object.entries(attrs).map(([k, v]) => [camel(k), v])) }),
      )}
    </svg>
  );
}

export const isIconName = (v: string): v is IconName => Object.prototype.hasOwnProperty.call(ICON_PATHS, v);
